import NotificationActions from "actions/Notification"
import ActionStatus from "components/ActionStatus"
import { listOfRoles } from "components/WithRoleAuthorization/WithRoleAuthorization"
import { ROUTES_NAMES } from 'constants/name.routes'
import { notificationStatus } from "constants/notificationStatus"
import { useEffect, useMemo, useState } from 'react'
import { MdOutlineModeEditOutline } from "react-icons/md"
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { Dispatch } from 'redux'
import NotificationService from "services/Notification"
import { UserDataType } from "types/autentication"
import { RootReducerState } from 'types/global'
import { NotificationAction, NotificationReducer, NotificationType } from 'types/notification'
import { isGraveObitoOrHasImageRisk } from "utils/notifyEvents"
import { EditButton } from "../IshikawaDiagram/styles"
import { HelpDescription, Subtitle, Title, checkboxStyle, notPerformStyle, } from "./styles"
import StaticDataVersioned from "./Version/Static"
import PrintContainer from "../components/PrintContainer"

interface LondonProtocolProps {
    tooltipAlert: string,
    notification: NotificationType
    statusIsArchivedOrFinished: boolean
    currentUser: UserDataType
    notificationStatusState: string

}

export const canEditLondonProtocol = (
    { loggedInUserIsResponsible, isSameLocation, isSameSector, notificationStatusState }:
        { loggedInUserIsResponsible: boolean, isSameLocation: boolean, isSameSector: boolean, notificationStatusState: string }) => {
    if (notificationStatusState === notificationStatus[3].label) {
        return [
            listOfRoles.admin,
            listOfRoles.location_qa,
            listOfRoles.corporate_quality_board
        ]
    } else {
        return [
            ...(loggedInUserIsResponsible ? [listOfRoles.admin] : []),
            ...(isSameLocation && isSameSector && loggedInUserIsResponsible ? [listOfRoles.location_manager] : []),
            ...(isSameLocation && loggedInUserIsResponsible ? [listOfRoles.location_qa] : []),
        ]
    }
}
const LondonProtocol = ({ notificationStatusState, tooltipAlert, notification, statusIsArchivedOrFinished, currentUser }: LondonProtocolProps) => {
    const { id } = useParams()
    const navigate = useNavigate()
    const notificationDispatch: Dispatch<NotificationAction> = useDispatch()

    const [notAllowed, setNotAllowed] = useState(false)
    const [disabled, setDisabled] = useState(false);

    const notificationSelector: NotificationReducer = useSelector((state: RootReducerState) => state.notificationsReducer)
    const londonProtocolUseMemo = useMemo(() => notificationSelector?.londonProtocol, [notificationSelector?.londonProtocol])

    const isSameLocation = useMemo(() => {
        return currentUser?.locations && currentUser?.locations?.filter((i) => i.sys_id === notification?.location_incident?.value).length > 0
    }, [currentUser, notification])

    const isSameSector = useMemo(() => {
        return currentUser?.locations && currentUser?.locations?.filter((i) => i.sys_id === notification?.location_incident?.value)[0]?.sectors.filter((i) => i.sys_id === notification?.incident_sector?.value).length > 0
    }, [currentUser, notification])

    const loggedInUserIsResponsible = useMemo(() => {
        return currentUser?.sys_id && currentUser?.sys_id ===
            notification?.u_assigned_to?.value
    }, [currentUser, notification])

    useEffect(() => {
        if (canEditLondonProtocol({ loggedInUserIsResponsible, isSameLocation, isSameSector, notificationStatusState })
            .includes(currentUser?.profile) && !statusIsArchivedOrFinished) {
            setNotAllowed(false)
        } else {
            setNotAllowed(true)
        }
    }, [loggedInUserIsResponsible, isSameLocation, isSameSector, notificationStatusState, statusIsArchivedOrFinished])

    useEffect(() => {
        NotificationActions.getLondonProtocolByNotificationId(notificationDispatch, id)
        NotificationActions.getTypesOfDiagnosis(notificationDispatch);
        NotificationActions.getNotificationLondonVaribles(notificationDispatch);
        NotificationActions.getNotificationFactors(notificationDispatch);
        NotificationActions.getNeverEvent(notificationDispatch);
        NotificationActions.getSentinelEvent(notificationDispatch);
    }, [currentUser])

    useEffect(() => {
        if (!notAllowed) {
            setDisabled(londonProtocolUseMemo?.do_not_perform_optional == 'true')
        }
    }, [notAllowed, londonProtocolUseMemo])

    const formLondonProtocol = () => {
        navigate(`${ROUTES_NAMES.notifications}/london_protocol/${id}`)
    }
    const onChangeCheckedNotPerform = () => {
        const LondonProtocolSN = {
            ...(londonProtocolUseMemo?.sys_id ? { sys_id: londonProtocolUseMemo?.sys_id } : {}),
            hospital_incident: id,
            do_not_perform_optional: !disabled
        }
        NotificationService.saveLondonProtocol(LondonProtocolSN, notificationSelector.notificationById).then((response: any) => {
            setDisabled(prev => !prev);
            NotificationActions.getLondonProtocolByNotificationId(notificationDispatch, id)
        }).catch((error) => {
            console.log(error)
        })

    };

    const hideOrShowCheckUnrealizedOptional = useMemo(() => {
        const imageRiskValue = notificationSelector?.notificationById?.u_image_risk?.value
        const damageValue = notificationSelector?.notificationById?.damage_level?.value;
        const hasNeverEvents = notificationSelector?.notificationById?.u_never_events_or_sentinel_event?.value == 'yes'

        const isOlder = notificationSelector?.notificationById?.u_probability_occurence?.value === ''
        if (isOlder) {
            const isGraveObitoOrHasImageRiskRequired = isGraveObitoOrHasImageRisk({
                damageLevelValue: damageValue,
                imageRiskValue: imageRiskValue
            })
            return !isGraveObitoOrHasImageRiskRequired;
        }
        const stateLondonProtocol = notificationSelector?.notificationProcessRequiredStepsRules?.londonProtocolMandatory
        return !hasNeverEvents && stateLondonProtocol === "Optional"
    }, [currentUser])

    /*
        const handlePrint = () => {
            const content = document.getElementById('staticDataContainer');
            if (!content) return;
          
            const printWindow = window.open('', '', 'width=1200,height=920');
            if (!printWindow) return;
          
            printWindow.document.write(`
              <html>
                <head>
                  <title>Imprimir</title>
                  <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
                </head>
                <body class="p-4">
                  ${content.innerHTML}
                </body>
              </html>
            `);
          
            printWindow.document.close();
            printWindow.focus();
          
            // ✅ Espera o conteúdo carregar antes de imprimir
            setTimeout(() => {
              printWindow.print();
              printWindow.close();
            }, 500); // 300~500ms costuma funcionar bem
          };
    */
    return (
        <div className="overflow-x-auto" data-testid="test-notification-treatment-step3">
            <div className="px-8 flex flex-row gap-12 mt-4 min-h-[500px]">
                <fieldset disabled={notAllowed}>
                    <div className="flex flex-col">
                        <Title>
                            Protocolo de Londres
                        </Title>
                        <Subtitle>
                            Ao preencher este protocolo, reconstruímos com detalhes todo o contexto da situação que levou ao incidente.
                            O seu objetivo é garantir que todas as suposições sejam levantadas, para auxiliar na reflexão das oportunidades de melhorias dos processos.
                        </Subtitle>
                        <HelpDescription>
                            Preenchimento obrigatório para as notificações graves, óbitos e com risco de imagem, facultativo para as demais.
                        </HelpDescription>


                        <div className="flex flex-row gap-5 mt-6 mb-10">
                            <EditButton data-testid="test-go-to-forum-button" disabled={disabled || notAllowed}
                                id="btnEdit"
                                type="button"
                                onClick={formLondonProtocol}
                                className={`${disabled || notAllowed ? 'bg-disabled text-textSelect font-normal' : ''}`}
                            >
                                <div className="w-[202px] flex justify-center items-center gap-3">
                                    <MdOutlineModeEditOutline size={18} color={`${!disabled && !notAllowed ? 'white' : '#4F4F4F'}`} />
                                    <span className="inline-block align-middle">{!londonProtocolUseMemo?.sys_id ? 'Preencher protocolo' : 'Editar protocolo'}</span>
                                </div>
                            </EditButton>

                            {londonProtocolUseMemo?.sys_id && londonProtocolUseMemo?.date_of_patient_admission &&
                                <PrintContainer
                                    title="Protocolo de Londres"
                                    buttonLabel="Exportar PDF"
                                    disabled={false}
                                    containerId="staticDataContainer" />}

                            {hideOrShowCheckUnrealizedOptional &&
                                <OptionalPerformToggle
                                    notAllowed={notAllowed}
                                    disabled={disabled}
                                    onChangeCheckedNotPerform={onChangeCheckedNotPerform} />
                            }
                        </div>
                        {tooltipAlert && (
                            <div className="px-6" data-testid="test-tooltip-alert-3">
                                <ActionStatus text={tooltipAlert} status={1} />
                            </div>
                        )}
                        {(londonProtocolUseMemo?.sys_id && !!londonProtocolUseMemo?.date_of_patient_admission) &&
                            <StaticDataVersioned londonProtocol={londonProtocolUseMemo} />
                        }
                    </div>
                </fieldset>
            </div>
        </div>
    )
}

export { LondonProtocol }


const OptionalPerformToggle = ({ disabled, onChangeCheckedNotPerform, notAllowed }: { notAllowed: boolean, disabled: boolean, onChangeCheckedNotPerform: () => void }) => {
    return (
        <div data-testid="test-toggle-button" className="mt-2 block min-h-[1.5rem] pl-[1.5rem]">
            <input id={`do_not_perform_optional`}
                type="checkbox"
                className={`${checkboxStyle}  ${notAllowed ? "opacity-40" : "hover:cursor-pointer"}`}
                name={`do_not_perform_optional`}
                checked={disabled}
                onChange={onChangeCheckedNotPerform}
            />
            <label htmlFor={`do_not_perform_optional`} className={`${notPerformStyle}  ${notAllowed ? "opacity-40" : "hover:cursor-pointer"}`}>Não realizar o preenchimento</label>
        </div>
    )
}